import React from 'react'
import { AutoCompleteField, DateField, NumberField, TextField } from '~/components/fields'
import { OptionalLabel } from './optional-label'
import styled from 'styled-components'
import { masterStore } from '~/stores'

const EducationContainer = styled.div`
	margin-bottom: 24px;
	background-color: #ffffff;
	border-radius: 8px;
	border: 1px solid #e6e6e6;
	padding: 16px 16px 24px;
	display: flex;
	flex-direction: column;
	gap: 16px;
`

const StyledFieldWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	.MuiFormControl-root {
		width: 100%;
	}

	.MuiInputLabel-root {
		color: #263349;
		font-family: Inter;
		font-weight: 600;
		font-size: 14px;
		line-height: 1.7142857142857142em;
		margin-bottom: 4px;
	}

	.MuiInputBase-root {
		border: none;
		border-bottom: 1px solid #d1d1d1;
		border-radius: 0;
		padding: 0px 0px 8px;

		&:before {
			display: none;
		}

		&:after {
			display: none;
		}

		&:hover {
			border-bottom: 1px solid #d1d1d1;

			&:before {
				display: none;
			}
		}

		&.Mui-focused {
			border-bottom: 1px solid #d1d1d1;

			&:after {
				display: none;
			}
		}
	}
`

const RemoveButton = styled.button`
	flex: 1;
	justify-content: center;
	display: flex;
	background: none;
	border: none;
	color: #ff2727;
	font-family: Inter;
	font-weight: 700;
	font-size: 14px;
	line-height: 1.7142857142857142em;
	cursor: pointer;
	padding: 8px 0px;
	text-align: left;
	width: 100%;
	margin-top: 0px;

	&:hover {
		opacity: 0.8;
	}
`

const EducationItem = ({ index, onDelete }) => {
	return (
		<EducationContainer>
			<StyledFieldWrapper>
				<TextField name={`education.${index}.school`} label="SCHOOL_NAME" placeholder="Enter school name" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`education.${index}.city`} label="CITY" placeholder="Enter city" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`education.${index}.state`} label="STATE" placeholder="Enter state" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<DateField name={`education.${index}.startDate`} label="START_DATE" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<DateField name={`education.${index}.endDate`} label="END_DATE" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<DateField name={`education.${index}.graduationDate`} label="DEGREE_DATE" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<AutoCompleteField
					name={`education.${index}.degreeLevel`}
					label="DEGREE_NAME"
					placeholder={'$PLACEHOLDERS.SELECT_DEGREE_LEVEL'}
					options={masterStore.degreeLevels}
					endLabel={<OptionalLabel />}
				/>
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<TextField name={`education.${index}.areaOfStudy`} label="FIELD_OF_STUDY" placeholder="Enter area of study" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<StyledFieldWrapper>
				<NumberField name={`education.${index}.gpa`} label="GPA" placeholder="Enter GPA" endLabel={<OptionalLabel />} />
			</StyledFieldWrapper>
			<RemoveButton onClick={onDelete}>Remove</RemoveButton>
		</EducationContainer>
	)
}

export default EducationItem
